import "./RevenueChart.css";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler
);

function RevenueChart({ weeklyRevenue = [] }) {

  // Default labels
  let labels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  // Default values
  let revenueData = [0, 0, 0, 0, 0, 0, 0];

  if (weeklyRevenue.length > 0) {

    labels = weeklyRevenue.map((item) => item.day);

    revenueData = weeklyRevenue.map((item) => item.amount);

  }

  const data = {
    labels,

    datasets: [
      {
        label: "Revenue",

        data: revenueData,

        fill: true,

        borderColor: "#ff6b35",

        backgroundColor: "rgba(255,107,53,.15)",

        pointBackgroundColor: "#ff6b35",

        pointBorderColor: "#ffffff",

        pointRadius: 4,

        pointHoverRadius: 6,

        borderWidth: 3,

        tension: 0.4,
      },
    ],
  };

  const options = {

    responsive: true,

    maintainAspectRatio: false,

    plugins: {

      legend: {

        display: false,

      },

      tooltip: {

        callbacks: {

          label: function (context) {

            return `₹${context.raw.toLocaleString()}`;

          },

        },

      },

    },

    scales: {

      y: {

        beginAtZero: true,

        ticks: {

          callback: function (value) {

            return "₹" + value.toLocaleString();

          },

        },

      },

    },

  };

  return (

    <div className="revenue-chart-card">

      <div className="chart-header">

        <h2>

          Weekly Revenue

        </h2>

        <span>

          Last 7 Days

        </span>

      </div>

      <div className="chart-container">

        <Line
          data={data}
          options={options}
        />

      </div>

    </div>

  );

}

export default RevenueChart;